import { render, staticRenderFns } from "./manuales-modal.vue?vue&type=template&id=1017b386&"
import script from "./manuales-modal.component.ts?vue&type=script&lang=ts&"
export * from "./manuales-modal.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports